<template>
  <div class="mobile-wrapping">
    <header>
      <div class="mobile-logo">
        <img :src="logoUrl" class="mobile-logo-image" />
      </div>
    </header>

    <div id="main">
      <div style="align-content: center;justify-content: center;">
        <div class="mobile-payment-user-info">
          <el-row
            :gutter="2"
            align="middle"
            class="mobile-payment-user-info-row"
          >
            <el-col :span="8">
              <div>
                <el-avatar
                  :size="60"
                  :src="userInfo.avatar"
                  class="user-info-avatar"
                ></el-avatar>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="user-info">
                <div>NickName:</div>
                <div>User ID:</div>
                <div>Package:</div>
              </div>
            </el-col>

            <el-col :span="10">
              <div class="user-info">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo.uid }}</div>
                <div>{{ productInfo.diamond }} Diamonds</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="mobile-payment-divider"></div>

        <div class="mobile-payment-result">
          <el-row>
            <div class="mobile-payment-result-msg">
              <i
                class="el-alert__icon el-icon-success"
                v-if="isSuccess === 'true'"
              />
              <i class="el-alert__icon el-icon-error" v-else />
              <span class="msg-content">{{ msg }}</span>
            </div>
          </el-row>

          <!-- 价格 -->
          <el-row>
            <div class="mobile-payment-price">
              <span v-if="productInfo.price"
                >Amount: {{ productInfo.price }} USD</span
              >
            </div>
          </el-row>

          <!-- return -->
          <el-row>
            <div class="mobile-result-return">
              <el-button @click="back" type="primary" size="medium">Return</el-button
              >
            </div>
          </el-row>
        </div>
      </div>
    </div>

    <!-- 底图 -->
    <div class="mobile-main-image">
      <img :src="backgourpMain" />
    </div>
  </div>
</template>

<script>
import logo from '@/assets/images/recharge/mobile/logo.png'
import backgourpMain from '@/assets/images/recharge/mobile/backgourp_main.png'
import productConfig from '@/util/product'
import { userInfo } from '@/api/user'

export default {
  name: 'PaymentResultMobile',
  props: {
    msg: {
      type: String,
      default: 'success',
      required: true
    },
    isSuccess: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      logoUrl: logo,
      backgourpMain: backgourpMain,
      userInfo: {
        uid: '',
        nickname: '',
        avatar: ''
      },
      productList: [],
      productInfo: {
        diamond: '',
        price: '',
        productId: ''
      }
    }
  },
  mounted () {
    let query = this.$route.query || {}
    this.productList = productConfig

    this.productInfo.productId = query.productId || ''
    this.productInfo = this.getProduct(this.productInfo.productId)

    if (!query.uid) {
      this.$router.push({ name: 'Recharge' })
    } else {
      let avatar = ''
      let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
      if (userInfos[query.uid]) {
        this.userInfo.uid = query.uid
        this.userInfo.nickname = userInfos[query.uid].nickname || ''
        avatar = userInfos[query.uid].avatar || ''
        this.avatarHandle(avatar)
      } else {
        userInfo({uid: query.uid})
          .then(({ data }) => {
            if (data.uid) {
              let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
              userInfos[data.uid] = data
              window.localStorage.setItem('userinfos', JSON.stringify(userInfos))
              this.userInfo.uid = data.uid
              this.userInfo.nickname = data.nickname || ''
              avatar = data.avatar || ''
              this.avatarHandle(avatar)
            } else {
              this.$message({
                showClose: true,
                message: 'User not found',
                type: 'error'
              })
            }
            this.submitBtnDisable = false
          })
          .catch(() => {
            this.$message({
              showClose: true,
              message: 'Server err',
              type: 'error'
            })
            this.submitBtnDisable = true
          })
      }
    }
  },
  methods: {
    back () {
      this.$router.push({ name: 'Recharge' })
    },
    avatarHandle (userAvatar) {
      let avatar = 'none.jpg'
      if (userAvatar.startsWith('http')) {
        this.userInfo.avatar = userAvatar
      } else if (userAvatar) {
        let subfix = '.jpg'
        const avatars = userAvatar.split(':')
        if (userAvatar.startsWith('default')) {
          avatar = avatars[1] + subfix
        } else if (userAvatar.startsWith('special')) {
          subfix = '.png'
          avatar = avatars[1] + subfix
        }
        this.userInfo.avatar = require('@/assets/images/avatar/user/player_head_' + avatar)
      }
    },
    getProduct (productId) {
      let product = {}
      this.productList.forEach((item) => {
        if (item.productId === productId) {
          product = item
        }
      })
      return product
    }
  }
}
</script>

<style>
@media screen and (max-width: 750px) {
  .el-message {
    width: 60% !important;
    min-width: 320px;
  }
}

.mobile-uid-input-control .el-input-group__prepend {
  background-color: #4079b9;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  border: none;
}
.el-form-item__error {
  text-align: center;
  right: 0;
}

.mobile-product-list .el-row {
  margin-bottom: 20px;
}

.mobile-product-list .el-card {
  border: 0px;
}

.user-info-avatar {
  border: groove 2px #5786bf;
}

.mobile-payment-pay .mobile-payment-check-info .el-icon-success {
  width: 27px;
  height: 27px;
  color: #32c77e;
}

.mobile-product-list .is-disabled {
  color: #fff;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  width: 340px;
  height: 79px;
}
.mobile-product-list .is-disabled:hover {
  color: #fff;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  width: 340px;
  height: 79px;
}

.mobile-confirm-btn .el-button:hover {
  color: #fff;
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  width: 340px;
  height: 79px;
}

.mobile-result-return .el-button {
  width: 264px;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-wrapping {
  background: url("~@/assets/images/recharge/mobile/backgourp_payment.jpg")
    repeat-x;
  overflow: hidden;
  height: 100%;
  position: absolute;
  left: 0px;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}

header {
  width: 100%;
  height: 100px;
  position: absolute;
  background-color: #0a0c11;
  z-index: 5;
  top: 0;
  text-align: center;
}

.mobile-logo {
  display: inline-block;
  margin-top: 2px;
  margin-bottom: 2px;
}

.mobile-logo-image {
  width: 277px;
  height: 108px;
}

#main {
  width: 100%;
  top: 100px;
  position: absolute;
  z-index: 10;
}

.mobile-payment-user-info {
  width: 100%;
  height: 280px;
}

.mobile-payment-user-info-row {
  width: 100%;
  height: 280px;
  justify-content: center;
  align-items: center;
  display: -webkit-flex;
}

.mobile-payment-user-info .user-info {
  float: left;
  text-align: left;
  color: #ffffff;
}

.mobile-payment-user-info .user-info div {
  font-family: SourceHanSansCN-Regular;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-payment-divider {
  display: inline-block;
  background: url("~@/assets/images/recharge/mobile/payment-divider.png") center
    center no-repeat;
  width: 90%;
  height: 2px;
}

.mobile-payment-result {
  width: 100%;
}

.mobile-payment-result .mobile-payment-result-msg {
  margin-top: 100px;
}

.mobile-payment-result .mobile-payment-result-msg .el-icon-success {
  font-size: 66px;
  width: 70px;
  height: 66px;
  color: #32c77e;
}

.mobile-payment-result .mobile-payment-result-msg .el-icon-error {
  font-size: 66px;
  width: 70px;
  height: 66px;
  color: #f56c6c;
}

.mobile-payment-result .mobile-payment-result-msg .msg-content {
  font-family: SourceHanSansCN-Regular;
  font-size: 58px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-confirm-btn {
  background: url("~@/assets/images/recharge/mobile/confirm-btn.png") no-repeat;
  width: 617px;
  height: 101px;
  background-color: #9dffcf;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  color: #ffffff;
  font-family: SourceHanSansCN-Regular;
  font-size: 30px;
  border-radius: 4px;
  border: none;
}

.mobile-payment-result .mobile-payment-price {
  font-family: SourceHanSansCN-Regular;
  margin-top: 30px;
  font-size: 34px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}

.mobile-payment-result .mobile-result-return {
  margin-top: 40px;
}

.mobile-main-image {
  position: fixed;
  bottom: -100px;
}

.mobile-main-image img {
  opacity: 0.5;
  width: 100%;
}

footer {
  height: 76px;
  /* background:yellow; */
  width: 100%;
  position: absolute;
  z-index: 200;
  bottom: 20px;
  text-align: center;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/components/result/mobile.vue